import React, { useEffect, useState } from 'react';

/** Core */
import Input from '../../core/Input';
import Label from '../../core/Label';
import Icon from '../../core/Icon';
import DropdownInput from '../../core/DropdownInput';
import Buttons from '../../core/Buttons';

import Modal from '../../core/Modal';
import Alerts from '../../core/Alerts';

/** Modales */
import {
  Education,
  Language,
  Hobbies,
  Children,
  Supervisor,
  TrainingNeeds
} from '../Employee/Edition';

/** Iconos */
import LogoAtresmedia from '../../../../assets/images/logoatresmedia.svg';
import { Plus, Pencil, Trash } from '../../../../assets/images/index';

/** Estilos */
import { StyledDataFormUser, StyledCheckbox } from './style';

import {
  sexo,
  months,
  years,
  dataEducation,
  discapacidad
} from '../../../utils/mocks/js';
import {
  getDepartments,
  getSubDepartments,
  getLocations,
  getConsultants
} from '../../../utils/apiDataUserForm';

import {
  getUserDetails,
  setUserEditingData,
  setFormUserModal,
  getSocieties
} from '../../../utils/apiUser';

import { parseSelect } from '../../../utils/parseSelect';

const DataFormUser = props => {
  const { setfilledDataUser, changeAddress } = props;
  const [dataUser, setDataUser] = useState(null);

  const [modalHijos, setModalHijos] = useState(false);
  const [modalEstudios, setModalEstudios] = useState(false);
  const [modalIdiomas, setModalIdiomas] = useState(false);
  const [modalHobbies, setModalHobbies] = useState(false);
  const [modalTrainingNeeds, setModalTrainingNeeds] = useState(false);
  const [modalSupervisor, setModalSupervisor] = useState(false);
  const [otrasConsultoras, setOtrasConsultoras] = useState(false);

  /** datos inputs select */
  const [typology, setTypology] = useState(null);
  const [userName, setUserName] = useState(null);
  const [publicName, setPublicName] = useState(null);
  const [mail, setMail] = useState(null);
  const [mailPersonal, setMailPersonal] = useState(null);
  const [address, setAddress] = useState(null);

  const [partnerCompanies, setPartnerCompanies] = useState([]);
  const [partnerCompanie, setPartnerCompanie] = useState(null);

  const [societies, setSocieties] = useState([]);
  const [society, setSociety] = useState(null);

  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState(null);
  const [subdepartments, setSubdepartments] = useState([]);
  const [subdepartment, setsubdepartment] = useState(null);
  const [currentSubdepartment, setCurrentSubdepartment] = useState(
    'Subdepartamentos no disponibles'
  );
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState(null);
  const [currentArea, setCurrentArea] = useState('Areas no disponibles');

  const [locations, setLocations] = useState([]);
  const [currentLoc, setCurrentLoc] = useState(null);
  const [loc, setLoc] = useState(null);

  const [position, setPosition] = useState(null);
  const [supervisor, setSupervisor] = useState(null);
  const [category, setCategory] = useState(null);

  const [extension, setExtension] = useState(null);
  const [editExtension, setEditExtension] = useState(false);
  const [corporatePhone, setCorporatePhone] = useState(null);
  const [editCorporatePhone, setEditCorporatePhone] = useState(false);
  const [phone, setPhone] = useState(null);
  const [editPhone, setEditPhone] = useState(false);

  const [stateR, setStateR] = useState(null);
  const [gender, setGender] = useState(null);
  const [discapacity, setDiscapacity] = useState(null);
  const [discapacityName, setDiscapacityName] = useState(null);

  const [birthday, setBirthday] = useState(null);

  const [formation, setFormation] = useState([]);
  const [formationPublic, setFormationPublic] = useState(false);

  const [languages, setLanguages] = useState([]);
  const [languagesPublic, setLanguagesPublic] = useState(false);

  const [hobbies, setHobbies] = useState([]);
  const [hobbiesPublic, setHobbiesPublic] = useState(false);

  const [trainingNeeds, setTrainingNeeds] = useState([]);

  const [children, setChildren] = useState([]);

  const [modalSend, setModalSend] = useState(false);

  /** Errors  */
  const [errorForm] = useState([]);
  const [errorName, setErrorName] = useState({
    error: false,
    message: ''
  });
  const [errorMail, setErrorMail] = useState({
    error: false,
    message: ''
  });
  const [errorMailPersonal, setErrorMailPersonal] = useState({
    error: false,
    message: ''
  });
  const D = new Date();

  const setDpto = (dpto, subId = null, areaId = null) => {
    setDepartment(dpto);
    setCurrentSubdepartment('Subdepartamentos');
    setsubdepartment(null);
    setCurrentArea('Areas');
    setArea(null);
    getSubDepartments(dpto.value).then(sbdpto => {
      setSubdepartments(parseSelect(sbdpto));
      if (subId) {
        setCurrentSubdepartment(
          parseSelect(sbdpto).filter(dpt => dpt.value === subId.toString())[0]
            .text
        );
        setsubdepartment(
          parseSelect(sbdpto).filter(dpt => dpt.value === subId.toString())[0]
        );
        getSubDepartments(subId).then(areas => {
          setAreas(parseSelect(areas));
          if (areaId) {
            const areaSelected = parseSelect(areas).filter(
              area => area.value === areaId.toString()
            );
            if (areaSelected && areaSelected.length > 0) {
              setCurrentArea(areaSelected[0].text);
            }
            setArea(
              parseSelect(areas).filter(
                area => area.value === area.toString()
              )[0]
            );
          }
        });
      }
    });
  };

  // const getCivilStatus = irpfStatus => {
  // switch (irpfStatus) {
  // case 'SINGLE_SEPARATED_DIVORCED_WIDOWED':
  // return 'Soltero/a';
  // case 'MARRIED':
  // return 'Casado/a';
  // case 'OTHERS':
  // return 'Otras/No desea manifestarla';
  // default:
  // return '';
  // }
  // };
  useEffect(() => {
    getUserDetails().then(user => {
      setDataUser(user);
      setUserName(`${user.userProfile.name} ${user.userProfile.lastname}`);
      setTypology(user.userProfile.typology);
      setLoc(user.userProfile.location);
      if (user.userProfile.publicName) {
        setPublicName(`${user.userProfile.publicName}`);
      } else {
        setPublicName(`${user.userProfile.name}`);
      }
      if (user.userProfile.gender) {
        setGender(user.userProfile.gender);
      }
      if (user.userProfile.civilState) {
        setStateR(user.userProfile.civilState);
      }
      if (user.userProfile.email) {
        setMail(user.userProfile.email);
      }
      if (user.userProfile.personalEmail) {
        setMailPersonal(user.userProfile.personalEmail);
      }
      if (user.userDetail.userAddress) {
        setAddress(
          `${
            user.userDetail.userAddress.idSiglaDomicilio
              ? user.userDetail.userAddress.idSiglaDomicilio
              : 'C'
          }/ ${user.userDetail.userAddress.viaPublica &&
            user.userDetail.userAddress.viaPublica}, ${user.userDetail
            .userAddress.numeroVia &&
            `${user.userDetail.userAddress.numeroVia}, `} ${user.userDetail
            .userAddress.piso && `${user.userDetail.userAddress.piso}º, `}${user
            .userDetail.userAddress.puerta &&
            `${user.userDetail.userAddress.puerta}, `} ${user.userDetail
            .userAddress.poblacion &&
            `${user.userDetail.userAddress.poblacion}, `}`
        );
      }
      if (user.userProfile.birthDate) {
        setBirthday(user.userProfile.birthDate);
      }
      if (user.userProfile.category) {
        setCategory(user.userProfile.category);
      }
      if (user.userProfile.jobPosition) {
        setPosition(user.userProfile.jobPosition);
      }
      if (user.userProfile.supervisorName) {
        setSupervisor({
          text: user.userProfile.supervisorName,
          value: user.userProfile.supervisorId
        });
      }
      if (user.userProfile.extension) {
        setExtension(user.userProfile.extension);
      }
      if (user.userProfile.phones) {
        setPhone(user.userProfile.phones);
      }
      if (user.userProfile.corporatePhone) {
        setCorporatePhone(user.userProfile.corporatePhone);
      }
      if (user.userDetail.educations) {
        setFormation(user.userDetail.educations);
      }
      if (user.userDetail.educationsPublic) {
        setFormationPublic(user.userDetail.formationPublic);
      }
      if (user.userDetail.hobbies) {
        setHobbies(user.userDetail.hobbies);
      }
      if (user.userDetail.hobbiesPublic) {
        setHobbiesPublic(user.userDetail.hobbiesPublic);
      }
      if (user.userDetail.languages) {
        setLanguages(user.userDetail.languages);
      }
      if (user.userDetail.languagesPublic) {
        setLanguagesPublic(user.userDetail.languagesPublic);
      }
      if (user.userDetail.children) {
        setChildren(user.userDetail.children);
      }
      if (user.userDetail.trainingNeeds) {
        setTrainingNeeds(user.userDetail.trainingNeeds);
      }
      if (user.userProfile.disability) {
        setDiscapacity(user.userProfile.disability);
        setDiscapacityName(
          discapacidad.filter(ds => ds.value === user.userProfile.disability)[0]
            .text
        );
      }

      getDepartments().then(dtps => {
        setDepartments(parseSelect(dtps));
        setDpto(
          parseSelect(dtps).filter(
            dpt => dpt.value === user.userProfile.idDepartment.toString()
          )[0],
          user.userProfile.idSubDepartment,
          user.userProfile.idArea
        );
      });
      getLocations().then(loca => {
        setLocations(parseSelect(loca));
        if (user.userProfile.location) {
          setCurrentLoc(
            loca.filter(
              l => Object.keys(l)[0] === user.userProfile.location
            )[0][user.userProfile.location]
          );
        }
      });
      getConsultants().then(cn => {
        cn.push({ id: cn.length + 1, name: 'Otros' });
        setPartnerCompanies(cn);
        if (user.userProfile.idPartnerCompany) {
          setPartnerCompanie(
            cn.filter(c => c.id === user.userProfile.idPartnerCompany)[0]
          );
        }
      });
      getSocieties().then(soc => {
        const sociedades = [];
        soc.map(s =>
          sociedades.push({
            value: s.societyId,
            text: s.name
          })
        );

        setSocieties(sociedades);
        if (user.userProfile.societyId) {
          setSociety(
            sociedades.filter(a => a.value === user.userProfile.societyId)[0]
          );
        }
      }); /*
      getIRPFData().then(response => {
        setIrpfInformation(
          `Estado civil: ${response.irpfStatus.civilStatus &&
            getCivilStatus(
              response.irpfStatus.civilStatus
            )}\n\nProlongación de la vida laboral: ${
            response.irpfStatus.workLonger &&
            response.irpfStatus.workLonger === 'S'
              ? 'Sí'
              : 'No'
          }\n\nPagos por la adquisicion o rehabilitacion de la vivienda habitual: ${
            response.irpfStatus.purchaseRenovationMainResidence &&
            response.irpfStatus.purchaseRenovationMainResidence === 'S'
              ? 'Sí'
              : 'No'
          }`
        );
      }); */
    });
  }, []);

  function mailValidation(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const controlErrors = () => {
    if (typology === 'INTERNAL') {
      if (position === null || position.length <= 0) {
        if (
          errorForm.findIndex(
            error => error.message === 'El campo cargo/puesto es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'El campo cargo/puesto es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'El campo cargo/puesto es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo cargo/puesto es obligatorio'
          ),
          1
        );
      }
      if (supervisor === null) {
        if (
          errorForm.findIndex(
            error =>
              error.message === 'El campo responsable directo es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'El campo responsable directo es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error =>
            error.message === 'El campo responsable directo es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error =>
              error.message === 'El campo responsable directo es obligatorio'
          ),
          1
        );
      }
      if (gender === null) {
        if (
          errorForm.findIndex(
            error => error.message === 'El campo de sexo es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'El campo de sexo es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'El campo de sexo es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo de sexo es obligatorio'
          ),
          1
        );
      }
      if (department === null) {
        if (
          errorForm.findIndex(
            error => error.message === 'El campo departamento es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'El campo departamento es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'El campo departamento es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo departamento es obligatorio'
          ),
          1
        );
      }
      if (department !== null && subdepartment === null) {
        if (
          errorForm.findIndex(
            error => error.message === 'El campo subdepartamento es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'El campo subdepartamento es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'El campo subdepartamento es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo subdepartamento es obligatorio'
          ),
          1
        );
      }
      if (languages && languages.length <= 0) {
        if (
          errorForm.findIndex(
            error => error.message === 'Debes añadir al menos un idioma'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'Debes añadir al menos un idioma'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'Debes añadir al menos un idioma'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'Debes añadir al menos un idioma'
          ),
          1
        );
      }
      if (formation && formation.length <= 0) {
        if (
          errorForm.findIndex(
            error => error.message === 'Debes añadir al menos un estudio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'Debes añadir al menos un estudio'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'Debes añadir al menos un estudio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'Debes añadir al menos un estudio'
          ),
          1
        );
      }
    }
    if (typology === 'EXTERNAL') {
      if (partnerCompanie === null) {
        if (
          errorForm.findIndex(
            error => error.message === 'La consultora es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'La consultora es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error => error.message === 'La consultora es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'La consultora es obligatorio'
          ),
          1
        );
      }
      if (supervisor === null) {
        if (
          errorForm.findIndex(
            error =>
              error.message === 'El campo contacto Atresmedia es obligatorio'
          ) === -1
        ) {
          errorForm.push({
            error: true,
            message: 'El campo contacto Atresmedia es obligatorio'
          });
        }
      } else if (
        errorForm.findIndex(
          error =>
            error.message === 'El campo contacto Atresmedia es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error =>
              error.message === 'El campo contacto Atresmedia es obligatorio'
          ),
          1
        );
      }
    }

    // Control de errores para internal y external
    if (!loc.length > 0 || loc === null) {
      if (
        errorForm.findIndex(
          error => error.message === 'El campo centro de trabajo es obligatorio'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El campo centro de trabajo es obligatorio'
        });
      }
    } else if (
      errorForm.findIndex(
        error => error.message === 'El campo centro de trabajo es obligatorio'
      ) !== -1
    ) {
      errorForm.splice(
        errorForm.findIndex(
          error => error.message === 'El campo centro de trabajo es obligatorio'
        ),
        1
      );
    }

    if (typeof publicName !== 'string' || publicName.length <= 0) {
      setErrorName({ error: true, message: 'Este campo es obligatorio' });
      if (
        errorForm.findIndex(
          error => error.message === 'El campo nombre público es obligatorio'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El campo nombre público es obligatorio'
        });
      }
    } else {
      setErrorName({ error: false, message: '' });
      if (
        errorForm.findIndex(
          error => error.message === 'El campo nombre público es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo nombre público es obligatorio'
          ),
          1
        );
      }
    }

    if (typeof mail !== 'string' || mail.length <= 0) {
      setErrorMail({ error: true, message: 'Este campo es obligatorio' });
      if (
        errorForm.findIndex(
          error => error.message === 'El campo email es obligatorio'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El campo email es obligatorio'
        });
      }
    } else if (!mailValidation(mail)) {
      setErrorMail({ error: true, message: 'No cumple el formato' });
      if (
        errorForm.findIndex(
          error => error.message === 'El campo email no cumple el formato'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El campo email no cumple el formato'
        });
      }
    } else {
      setErrorMail({ error: false, message: '' });
      if (
        errorForm.findIndex(
          error => error.message === 'El campo email es obligatorio'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo email es obligatorio'
          ),
          1
        );
      }
      if (
        errorForm.findIndex(
          error => error.message === 'El campo email no cumple el formato'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error => error.message === 'El campo email no cumple el formato'
          ),
          1
        );
      }
    }

    if (
      mailPersonal !== null &&
      mailPersonal.length > 0 &&
      !mailValidation(mailPersonal)
    ) {
      setErrorMailPersonal({ error: true, message: 'No cumple el formato' });

      if (
        errorForm.findIndex(
          error =>
            error.message === 'El campo email personal no cumple el formato'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El campo email personal no cumple el formato'
        });
      }
    } else {
      setErrorMailPersonal({ error: false, message: '' });
      if (
        errorForm.findIndex(
          error =>
            error.message === 'El campo email personal no cumple el formato'
        ) !== -1
      ) {
        errorForm.splice(
          errorForm.findIndex(
            error =>
              error.message === 'El campo email personal no cumple el formato'
          ),
          1
        );
      }
    }

    if (phone && Number.isNaN(Number(phone)) !== false) {
      if (
        errorForm.findIndex(
          error => error.message === 'El móvil debe ser un número'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El móvil debe ser un número'
        });
      }
    } else if (
      errorForm.findIndex(
        error => error.message === 'El móvil debe ser un número'
      ) !== -1
    ) {
      errorForm.splice(
        errorForm.findIndex(
          error => error.message === 'El móvil debe ser un número'
        ),
        1
      );
    }

    if (corporatePhone && Number.isNaN(Number(corporatePhone)) !== false) {
      if (
        errorForm.findIndex(
          error => error.message === 'El teléfono debe ser un número'
        ) === -1
      ) {
        errorForm.push({
          error: true,
          message: 'El teléfono debe ser un número'
        });
      }
    } else if (
      errorForm.findIndex(
        error => error.message === 'El teléfono debe ser un número'
      ) !== -1
    ) {
      errorForm.splice(
        errorForm.findIndex(
          error => error.message === 'El teléfono debe ser un número'
        ),
        1
      );
    }
  };

  /** ENVIO FORMULARIO */
  const sendForm = () => {
    controlErrors();
    const userEditingData = { ...dataUser };
    if (errorForm) {
      userEditingData.userDetail = {
        ...userEditingData.userDetail,
        languages: languages && languages,
        languagesPublic: languagesPublic && languagesPublic
      };

      userEditingData.userDetail = {
        ...userEditingData.userDetail,
        children: children && children
      };

      userEditingData.userDetail = {
        ...userEditingData.userDetail,
        educations: formation && formation,
        educationsPublic: formationPublic && formationPublic
      };

      userEditingData.userDetail = {
        ...userEditingData.userDetail,
        hobbies: hobbies && hobbies,
        hobbiesPublic: hobbiesPublic && hobbiesPublic
      };

      userEditingData.userDetail = {
        ...userEditingData.userDetail,
        trainingNeeds: trainingNeeds && trainingNeeds
      };

      userEditingData.userProfile = {
        ...userEditingData.userProfile,
        email: mail && mail,
        publicName: publicName && publicName,
        idDepartment:
          department && typology === 'INTERNAL'
            ? Number(department.value)
            : dataUser.userProfile.idDepartment,
        idSubDepartment:
          subdepartment && typology === 'INTERNAL'
            ? Number(subdepartment.value)
            : dataUser.userProfile.idSubDepartment,
        idArea:
          area && typology === 'INTERNAL'
            ? Number(area.value)
            : dataUser.userProfile.idArea,
        societyId: society && society.value,
        location: loc,
        birthDate: birthday && birthday,
        idPartnerCompany: partnerCompanie && partnerCompanie.id,
        gender: gender && gender,
        civilState: stateR && stateR,
        disability: discapacity && discapacity,
        personalEmail: mailPersonal && mailPersonal,
        corporatePhone: corporatePhone && corporatePhone,
        phones: phone && phone,
        extension: extension && extension,
        jobPosition: position && position,
        supervisorId: supervisor && supervisor.value,
        supervisorName: supervisor && supervisor.text
      };
    }

    for (const propName in userEditingData.userProfile) {
      if (
        userEditingData.userProfile[propName] === null ||
        userEditingData.userProfile[propName] === undefined ||
        userEditingData.userProfile[propName].length === 0
      ) {
        delete userEditingData.userProfile[propName];
      }
    }

    for (const propName in userEditingData.userDetail) {
      if (
        userEditingData.userDetail[propName] === null ||
        userEditingData.userDetail[propName] === undefined ||
        userEditingData.userDetail[propName].length === 0
      ) {
        delete userEditingData.userDetail[propName];
      }
    }

    if (errorForm.length === 0) {
      setUserEditingData(userEditingData).then(() => {
        setFormUserModal({ userId: dataUser.userId });
        if (setfilledDataUser) {
          setfilledDataUser(true);
        }
      });
      // if (editMode) {
      setModalSend(true);
      // }
    }
  };

  /** ENVIO DATOS MODALES */
  const sendModalData = (data, type) => {
    switch (type) {
      case 'children':
        dataUser.userDetail = {
          ...dataUser.userDetail,
          children: data && data
        };
        break;
      case 'trainingNeeds':
        dataUser.userDetail = {
          ...dataUser.userDetail,
          trainingNeeds: data && data
        };
        break;
      case 'formation':
        dataUser.userDetail = {
          ...dataUser.userDetail,
          educations: data && data,
          educationsPublic: formationPublic && formationPublic
        };
        break;
      case 'languages':
        dataUser.userDetail = {
          ...dataUser.userDetail,
          languages: data && data,
          languagesPublic: languagesPublic && languagesPublic
        };
        break;
      case 'hobbies':
        dataUser.userDetail = {
          ...dataUser.userDetail,
          hobbies: data && data,
          hobbiesPublic: hobbiesPublic && hobbiesPublic
        };
        break;
      default:
        break;
    }
    setUserEditingData(dataUser).then(() => {});
  };

  return (
    <StyledDataFormUser>
      <header className="form-header">
        {true && (
          <>
            <div className="form-logo">
              <Icon className="form-logo-txt" svg={LogoAtresmedia} />
            </div>
            <p className="form-saludo">
              Hola {userName}, para completar el alta en la intranet es
              necesario confirmar algunos datos:
            </p>
          </>
        )}
      </header>
      <main>
        <form action="#">
          {/** 4) Nombre público */}
          <div className="form-box">
            <Label
              className="form-label"
              label="Nombre público que quieres mostrar en la intranet:"
            />
            <div className="wrapped-campo">
              <Input
                className="form-input"
                placeholder={`${publicName || 'Nombre público'}`}
                errorTitle={errorName.error ? errorName.message : ''}
                onChange={e => setPublicName(e)}
              />
              <span className="form-publico">p</span>
              <span className="form-obligatorio">*</span>
            </div>
          </div>

          {/** 5) Nombre y apellidos */}
          <div className="form-box">
            <Label className="form-label" label="Nombre y apellidos:" />
            <div className="wrapped-campo">
              <Input
                className="form-input"
                placeholder={`${userName}`}
                disabled
              />
              <span className="form-publico">p</span>
            </div>
          </div>

          {/** 6) Sociedad */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Sociedad:" />
              <div className="wrapped-campo">
                <DropdownInput
                  className="form-dropdown"
                  list={societies}
                  label={society ? society.text : 'Seleccionar sociedad'}
                  disabled
                />
              </div>
            </div>
          )}

          {/** 7-8-9) Departamento/Subdepartamento/Area */}
          {typology === 'INTERNAL' && (
            <div className="form-box form-box--start">
              <Label
                className="form-label"
                label="Departamento, subdepartamento y área al que perteneces:"
              />
              <div className="wrapped-campo-vertical">
                <div className="wrapped-campo">
                  <DropdownInput
                    className="form-dropdown"
                    list={departments}
                    label={
                      department ? department.text : 'Seleccionar departamento'
                    }
                    onSelect={e => setDpto(e)}
                  />
                  <span className="form-publico">p</span>
                  <span className="form-obligatorio">*</span>
                </div>
                <div className="wrapped-campo">
                  <DropdownInput
                    key={currentSubdepartment}
                    className="form-dropdown"
                    list={subdepartments}
                    disabled={subdepartments.length === 0}
                    label={currentSubdepartment}
                    onSelect={e => {
                      setDpto(department, e.value);
                    }}
                  />
                  <span className="form-publico">p</span>
                  <span className="form-obligatorio">*</span>
                </div>
                <div className="wrapped-campo">
                  <DropdownInput
                    key={currentArea}
                    className="form-dropdown"
                    list={areas}
                    disabled={areas.length === 0}
                    label={currentArea}
                    onSelect={e => {
                      setArea(e);
                      setCurrentArea(e.text);
                    }}
                  />
                  <span className="form-publico">p</span>
                  <span className="form-obligatorio">*</span>
                </div>
              </div>
            </div>
          )}

          {/** 10) Estructura (Oculto) */}

          {/** 11) Categoria */}
          {typology === 'INTERNAL' && (
            <div className="form-box form-box--start">
              <Label className="form-label" label="Tu categoría:" />
              <div className="wrapped-campo-vertical">
                <div className="wrapped-campo">
                  <Input
                    className="form-input"
                    placeholder={category}
                    disabled
                  />
                </div>
              </div>
            </div>
          )}

          {/** 12) Cargo/Puesto */}
          {typology === 'INTERNAL' && (
            <div className="form-box form-box--start">
              <Label className="form-label" label="Tu cargo/puesto:" />
              <div className="wrapped-campo-vertical">
                <div className="wrapped-campo">
                  <Input
                    className="form-input"
                    onChange={setPosition}
                    placeholder={position || 'Escribe aquí tu cargo/puesto'}
                  />
                  <span className="form-publico">p</span>
                  <span className="form-obligatorio">*</span>
                </div>
              </div>
            </div>
          )}

          {/** 13) Centro de trabajo */}
          <div className="form-box">
            <Label className="form-label" label="Tu centro de trabajo:" />
            <div className="wrapped-campo">
              <DropdownInput
                className="form-dropdown"
                list={locations}
                label={currentLoc || `Seleccionar centro de trabajo`}
                error={false}
                onSelect={e => setLoc(e.value)}
              />
              <span className="form-publico">p</span>
              <span className="form-obligatorio">*</span>
            </div>
          </div>

          {/** 14) Centro coste (Oculto) */}

          {/** 15) Responsable Directo o Contacto ATRESMEDIA */}
          <div className="form-box">
            <Label
              className="form-label"
              label={
                typology === 'INTERNAL'
                  ? 'Responsable directo:'
                  : 'Contacto Atresmedia:'
              }
            />
            <div className="wrapped-campo">
              <Input
                className="form-input"
                placeholder={
                  (supervisor && supervisor.text) ||
                  (typology === 'INTERNAL'
                    ? 'Responsable directo'
                    : 'Contacto Atresmedia')
                }
                disabled
              />
              <button
                type="button"
                className="form-btn form-btn-lapiz"
                onClick={() => {
                  setModalSupervisor(true);
                }}
              >
                <Icon className="form-icon form-icon-lapiz" svg={Pencil} />
              </button>
              {typology === 'EXTERNAL' && (
                <span className="form-publico">p</span>
              )}
              <span className="form-obligatorio">*</span>
            </div>
          </div>

          {/** 16) Email corporativo */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Tu email corporativo:" />
              <div className="wrapped-campo">
                <Input
                  className="form-input"
                  placeholder={mail}
                  errorTitle={errorMail.error ? errorMail.message : ''}
                  onChange={e => setMail(e)}
                />
                <span className="form-publico">p</span>
                <span className="form-obligatorio">*</span>
              </div>
            </div>
          )}

          {/** 17) Teléfonos Extension */}
          <div className="form-box form-box--start">
            <Label className="form-label" label="Tu/s teléfono/s:" />
            <div className="wrapped-campo-vertical">
              <div className="wrapped-campo wrapped-campo--tlf">
                <span className="txt-campo">Extensión</span>{' '}
                {editExtension && (
                  <Input
                    className="form-input"
                    placeholder={extension}
                    onChange={e => setExtension(e)}
                    onBlur={() => setEditExtension(false)}
                  />
                )}
                {extension && !editExtension && <span>{extension}</span>}
                {!extension && !editExtension && (
                  <Buttons
                    className="form-btn-plus"
                    type="button"
                    secondary
                    onClick={() => setEditExtension(true)}
                  >
                    <Icon className="form-icon-plus" svg={Plus} />
                  </Buttons>
                )}
                {extension && !editExtension && (
                  <>
                    <button
                      type="button"
                      className="form-btn form-btn-lapiz"
                      onClick={() => {
                        setEditExtension(true);
                      }}
                    >
                      <Icon
                        className="form-icon form-icon-lapiz"
                        svg={Pencil}
                      />
                    </button>
                    <button
                      type="button"
                      className="form-btn form-btn-papelera"
                      onClick={() => setExtension(null)}
                    >
                      <Icon
                        className="form-icon form-icon-papelera"
                        svg={Trash}
                        hover
                      />
                    </button>
                  </>
                )}
                <span className="form-publico">p</span>
              </div>

              {/** 18) Teléfonos Corporativo */}
              {typology === 'INTERNAL' && (
                <div className="wrapped-campo wrapped-campo--tlf">
                  <span className="txt-campo">Corporativo</span>{' '}
                  {editCorporatePhone && (
                    <Input
                      className="form-input"
                      placeholder={corporatePhone}
                      onChange={e => setCorporatePhone(e)}
                      onBlur={() => setEditCorporatePhone(false)}
                    />
                  )}
                  {corporatePhone && !editCorporatePhone && (
                    <span>{corporatePhone}</span>
                  )}
                  {!corporatePhone && !editCorporatePhone && (
                    <Buttons
                      className="form-btn-plus"
                      type="button"
                      secondary
                      onClick={() => setEditCorporatePhone(true)}
                    >
                      <Icon className="form-icon-plus" svg={Plus} />
                    </Buttons>
                  )}
                  {corporatePhone && !editCorporatePhone && (
                    <>
                      <button
                        type="button"
                        className="form-btn form-btn-lapiz"
                        onClick={() => {
                          setEditCorporatePhone(true);
                        }}
                      >
                        <Icon
                          className="form-icon form-icon-lapiz"
                          svg={Pencil}
                        />
                      </button>
                      <button
                        type="button"
                        className="form-btn form-btn-papelera"
                        onClick={() => setCorporatePhone(null)}
                      >
                        <Icon
                          className="form-icon form-icon-papelera"
                          svg={Trash}
                          hover
                        />
                      </button>
                    </>
                  )}
                  <span className="form-publico">p</span>
                </div>
              )}

              {/** 19) Teléfonos Móvil */}
              <div className="wrapped-campo wrapped-campo--tlf">
                <span className="txt-campo">Móvil</span>{' '}
                {editPhone && (
                  <Input
                    className="form-input"
                    placeholder={phone}
                    onChange={e => setPhone(e)}
                    onBlur={() => setEditPhone(false)}
                  />
                )}
                {phone && !editPhone && <span>{phone}</span>}
                {!phone && !editPhone && (
                  <Buttons
                    className="form-btn-plus"
                    type="button"
                    disabled={false}
                    secondary
                    onClick={() => setEditPhone(true)}
                  >
                    <Icon className="form-icon-plus" svg={Plus} />
                  </Buttons>
                )}
                {phone && !editPhone && (
                  <>
                    <button
                      type="button"
                      className="form-btn form-btn-lapiz"
                      onClick={() => {
                        setEditPhone(true);
                      }}
                    >
                      <Icon
                        className="form-icon form-icon-lapiz"
                        svg={Pencil}
                      />
                    </button>
                    <button
                      type="button"
                      className="form-btn form-btn-papelera"
                      onClick={() => setPhone(null)}
                    >
                      <Icon
                        className="form-icon form-icon-papelera"
                        svg={Trash}
                        hover
                      />
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          {/** 20) Domicilio */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Tu domicilio:" />
              <div className="wrapped-campo">
                <Input
                  multiline
                  className="form-input"
                  placeholder={address || 'Dirección'}
                  disabled
                />
              </div>
              <Buttons type="button" secondary onClick={() => changeAddress()}>
                Editar
              </Buttons>
            </div>
          )}

          {/** 20) Datos Bancarios */}

          {/** 21) Email Personal */}
          <div className="form-box">
            <Label className="form-label" label="Tu email de trabajo:" />
            <div className="wrapped-campo">
              <Input
                className="form-input"
                placeholder={mailPersonal || 'Email de trabajo'}
                errorTitle={
                  errorMailPersonal.error ? errorMailPersonal.message : ''
                }
                onChange={setMailPersonal}
              />
              {typology === 'EXTERNAL' && (
                <span className="form-publico">p</span>
              )}
            </div>
          </div>

          {/** 22) Discapacidad */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Grado de discapacidad:" />
              <div className="wrapped-campo">
                <DropdownInput
                  className="form-dropdown"
                  list={discapacidad}
                  label={discapacityName || 'Grado de discapacidad'}
                  onSelect={e => setDiscapacity(e.value)}
                />
                <span className="form-obligatorio">*</span>
              </div>
            </div>
          )}

          {/** 23) Sexo */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Sexo:" />
              <div className="wrapped-campo">
                <DropdownInput
                  className="form-dropdown"
                  list={sexo}
                  /* eslint-disable */
                label={
                  gender
                    ? gender === 'H'
                      ? 'Masculino'
                      : 'Femenino'
                    : 'Seleccionar sexo'
                }
                /* eslint-enable */
                  onSelect={e => setGender(e.value)}
                />
                <span className="form-obligatorio">*</span>
              </div>
            </div>
          )}

          {/** 24) Fecha nacimiento */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Fecha de nacimiento:" />
              <div className="wrapped-campo">
                <Input
                  className="form-input"
                  placeholder={birthday || ''}
                  disabled
                />
                <Label htmlFor="Birthday" />
              </div>
            </div>
          )}

          {/** 25) Consultora - SOLO EXTERNOS  */}
          {typology === 'EXTERNAL' && (
            <div className="form-box form-box--start">
              <Label className="form-label" label="Consultora:" />
              <div className="wrapped-campo-vertical">
                <div className="wrapped-campo">
                  <DropdownInput
                    className="form-dropdown"
                    list={partnerCompanies}
                    label={`${
                      partnerCompanie
                        ? partnerCompanie.name
                        : 'Seleccionar consultora'
                    }`}
                    onSelect={itemSelected => {
                      if (itemSelected.name === 'Otros') {
                        setOtrasConsultoras(true);
                      } else {
                        setOtrasConsultoras(false);
                        setPartnerCompanie(itemSelected);
                      }
                    }}
                  />
                  <span className="form-obligatorio">*</span>
                </div>
                {otrasConsultoras && (
                  <div className="wrapped-campo">
                    <Input
                      className="form-input"
                      onChange={e => setPartnerCompanie(e)}
                      placeholder="Escribe el nombre de la consultora"
                    />
                    <span className="form-publico">p</span>
                    <span className="form-obligatorio">*</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/** 28) Hijos */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label
                className="form-label"
                label="Hijos: **Para cambios en el IRPF lo tienes que solicitar en el apartado 'Tus datos IRPF'"
              />
              <div className="wrapped-campo">
                {children.length > 0 ? `Hijos: ${children.length}` : <span />}
                <Buttons
                  className="form-btn-plus"
                  type="button"
                  secondary
                  onClick={() => {
                    setModalHijos(true);
                  }}
                >
                  <Icon className="form-icon-plus" svg={Plus} />
                </Buttons>
              </div>
            </div>
          )}
          {/** 30) Necesidades de Formación */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Necesidades formación:" />

              <div className="wrapped-campo">
                {trainingNeeds.length > 0 ? (
                  `Formación: ${trainingNeeds.length}`
                ) : (
                  <span />
                )}
                <Buttons
                  className="form-btn-plus"
                  type="button"
                  secondary
                  onClick={() => {
                    setModalTrainingNeeds(true);
                  }}
                >
                  <Icon className="form-icon-plus" svg={Plus} />
                </Buttons>
              </div>
            </div>
          )}

          {/** 34) Estudios */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Estudios:" />
              <div className="wrapped-campo">
                {formation.length > 0 ? (
                  `Estudios: ${formation.length}`
                ) : (
                  <span />
                )}
                <StyledCheckbox
                  checked={formationPublic}
                  onChange={() => {
                    setFormationPublic(!formationPublic);
                  }}
                  label="Campo público"
                />
                <Buttons
                  className="form-btn-plus"
                  type="button"
                  secondary
                  onClick={() => {
                    setModalEstudios(true);
                  }}
                >
                  <Icon className="form-icon-plus" svg={Plus} />
                </Buttons>
                <span className="form-obligatorio">*</span>
              </div>
            </div>
          )}

          {/** 35) Idiomas */}
          {typology === 'INTERNAL' && (
            <div className="form-box">
              <Label className="form-label" label="Idiomas:" />
              <div className="wrapped-campo">
                {languages.length > 0 ? (
                  `Idiomas: ${languages.length}`
                ) : (
                  <span />
                )}
                <StyledCheckbox
                  checked={languagesPublic}
                  onChange={() => {
                    setLanguagesPublic(!languagesPublic);
                  }}
                  label="Campo público"
                />
                <Buttons
                  className="form-btn-plus"
                  type="button"
                  secondary
                  onClick={() => {
                    setModalIdiomas(true);
                  }}
                >
                  <Icon className="form-icon-plus a" svg={Plus} />
                </Buttons>
                <span className="form-obligatorio">*</span>
              </div>
            </div>
          )}

          {/** 36) Hobbies */}
          {true && (
            <div className="form-box">
              <Label className="form-label" label="Hobbies:" />

              <div className="wrapped-campo">
                {hobbies.length > 0 ? `Hobbies: ${hobbies.length}` : <span />}
                <StyledCheckbox
                  checked={hobbiesPublic}
                  onChange={() => {
                    setHobbiesPublic(!hobbiesPublic);
                  }}
                  label="Campo público"
                />
                <Buttons
                  className="form-btn-plus"
                  type="button"
                  secondary
                  onClick={() => {
                    setModalHobbies(true);
                  }}
                >
                  <Icon className="form-icon-plus" svg={Plus} />
                </Buttons>
              </div>
            </div>
          )}
          <div className="form-footer">
            {errorForm.length > 0 &&
              errorForm.map(error => (
                <Alerts
                  key={error.message}
                  className="alerts"
                  type="error"
                  visible
                >
                  {error.message}
                </Alerts>
              ))}
            <p className="form-txt-obligatorio">
              Los campos marcados con (*) son obligatorios
            </p>
            <p className="form-txt-obligatorio">
              Los campos marcados con (p) son públicos
            </p>
            <Buttons type="button" secondary onClick={() => sendForm()}>
              Guardar
            </Buttons>
          </div>
        </form>
      </main>
      {modalSend && (
        <Modal
          title="Datos de usuario"
          clickCloseIcon={() => setModalSend(false)}
        >
          <span>Datos guardados correctamente</span>
        </Modal>
      )}
      {modalSupervisor && (
        <Supervisor
          setEmployeeSelected={e => {
            setSupervisor(e);
            setModalSupervisor(false);
          }}
          onCloseModal={() => setModalSupervisor(false)}
        />
      )}
      {modalHijos && (
        <Children
          formUser
          dataChildren={children}
          onAcceptModal={e => {
            sendModalData(e, 'children');
            setChildren(e);
            setModalHijos(false);
          }}
          onCloseModal={() => setModalHijos(false)}
        />
      )}
      {modalEstudios && (
        <Education
          formUser
          dataEducation={formation.length > 0 ? formation : dataEducation}
          listMonths={months}
          listYears={years}
          selectedMonths={
            D.getMonth() + 1 < 10 ? `0${D.getMonth() + 1}` : D.getMonth() + 1
          }
          selectedYears={`${D.getFullYear()}`}
          onCloseModal={() => setModalEstudios(false)}
          onAcceptModal={e => {
            sendModalData(e, 'formation');
            setFormation(e);
            setModalEstudios(false);
          }}
        />
      )}
      {modalIdiomas && (
        <Language
          formUser
          dataLanguage={languages}
          onCloseModal={() => setModalIdiomas(false)}
          onAcceptModal={e => {
            sendModalData(e, 'languages');
            setLanguages(e);
            setModalIdiomas(false);
          }}
        />
      )}
      {modalHobbies && (
        <Hobbies
          formUser
          title="Hobbies"
          dataHobbies={hobbies}
          onCloseModal={() => setModalHobbies(false)}
          onAcceptModal={e => {
            sendModalData(e, 'hobbies');
            setHobbies(e);
            setModalHobbies(false);
          }}
        />
      )}
      {modalTrainingNeeds && (
        <TrainingNeeds
          title="Necesidades de formación"
          dataTrainingNeeds={trainingNeeds}
          onCloseModal={() => setModalTrainingNeeds(false)}
          onAcceptModal={e => {
            sendModalData(e, 'trainingNeeds');
            setTrainingNeeds(e);
            setModalTrainingNeeds(false);
          }}
        />
      )}
    </StyledDataFormUser>
  );
};

export default DataFormUser;
